import axios from 'axios';
import store from '@/store/index';
import router from '../router';

import { getToken } from './auth';

const api = axios.create({
  // baseURL: '/api',

  baseURL: 'https://backend.blitzar.com.br/api',
  // baseURL: 'https://backendqa.blitzar.com.br/api',

  //baseURL: 'http://localhost:3333/api',
  //ATTENTION
});

api.interceptors.request.use(async (config) => {
  //const token = store.state.user.token;

  const { token } = JSON.parse(getToken()) ? JSON.parse(getToken()) : { token: null };

  if (token && token.length) {
    // && store.state.template?.accessConfig?.accessControl) {
    config.headers.Authorization = `${token}`;
  } else {
    config.headers.Authorization = '3116d460-7cb1-11ea-bc55-0242ac130003';
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      // console.log('Intercept 200:', response);
    }
    return response;
  },
  (error) => {
    console.log('err', error);
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          // console.log('Intercept 400:', error.response);
          if (error.response.data ? error.response.data.error == 'Authorization unidentified' : false) {
            console.log('Intercept Authorization error:');
            router
              .push({
                name: 'Home',
                // path: "/#/",
              })
              .then(() => {
                //this.$store.commit('resetUser');
                store.commit('resetUser');
              })
              .catch((err) => console.error(err));
          }
          return Promise.reject(error);

        case 403: //unauthorized
          if (error.response.data ? error.response.data.error == 'Authorization unidentified' : false) {
            console.log('unauthorized');

            if (router.currentRoute.name !== 'Register') {
              router
                .push({
                  name: 'Home',
                })
                .then(() => {
                  store.commit('resetUser');
                })
                .catch((err) => console.error(err));
            } else {
              store.commit('resetUser');
            }
          }
          break;
        case 440: //session expired
          if (error.response.data ? error.response.data.error == 'Authorization unidentified' : false) {
            console.log('session expired');
            router
              .push({
                name: 'Home',
                // path: "/#/",
                // query: { redirect: router.currentRoute.fullPath }
              })
              .then(() => {
                //this.$store.commit('resetUser');
                store.commit('resetUser');
              })
              .catch((err) => console.error(err));
          }
          break;
        case 401:
          console.log(401);
          return Promise.reject(error);
          break;
        case 404:
          alert('page not exist');
          break;
        case 502:
          break;

        default:
          return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);
export default api;
